export const campaignCities = [
  "Hradec Králové",
  "Pardubice",
  "Zlín",
  "Kladno",
  "Most",
  "Jihlava",
  "Karlovy Vary",
  "Mladá Boleslav",
  "Chomutov",
  "Prostějov",
  "Přerov",
  "Třebíč",
  "Kolín",
  "Příbram",
  "Cheb",
  "Kroměříž",
  "Vsetín",
  "Chrudim",
  "Havlíčkův Brod",
  "Hodonín",
  "Klatovy",
  "Valašské Meziříčí",
  "Litvínov",
  "Sokolov",
  "Kutná Hora",
  "Vyškov",
  "Mělník",
  "Žďár nad Sázavou",
  "Mariánské Lázně",
] as const;
